import {
  getProdDataV1Data,
  patchProdDataV1Data,
  postProdDataV1Data,
} from 'services/prodDataV1';

export async function getProdDataData({ reqParams = {} }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await getProdDataV1Data({
      apiConfig: {
        params: reqParams,
      },
      url: '/productionData',
      withAuth: true,
    });
  } catch (error) {
    if (error.apiStatusCode === '404') {
      errorMessage = 'User Details Not Found';
    } else {
      errorMessage = error.message;
    }
  }
  return { response, errorMessage };
}

export async function postProdDataData({ data }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await postProdDataV1Data({
      data,
      url: '/productionData',
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}

export async function patchProdDataData({ data, indexId }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await patchProdDataV1Data({
      data,
      url: `/productionData/${indexId}`,
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}
